import { MAX_RECURRENCE_YEARS } from '../constants';

import recurrenceOptionsComponentUrl from './recurrenceOptionsComponent.html';
class RecurrenceOptionsController {
  constructor(Authentication, ShiftUtils, ShiftsEducation, Utils, sdk, $scope) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftUtils, ShiftsEducation, Utils, sdk, $scope });

    this.RRULE_INTERVAL_THIS_WEEK = sdk('constants').RRULE_INTERVAL_THIS_WEEK;

    this.repeatDatepickerAddon = {
      action: () => this.repeatOneYear(),
      template: `
        <button type="button" class="btn btn-cancel btn-block margin-top-10" ng-click="datepickerAddon.action()">
          Repeat one year
        </button>
      `,
    };

    this.repeatDatepickerOptions = {
      from: {},
      until: {
        datepickerClass: 'recurrence-until-datepicker-wrap',
        datepickerAddon: this.repeatDatepickerAddon,
      },
    };

    this.intervalModes = [
      { value: 0, label: 'Never' },

      /**
       * RRULE_INTERVAL_THIS_WEEK is an arbitrarily selected high enough value in order to keep modes unique here
       * User is unable to manipulate the untilDate in this mode which is automatically set to the
       * end of current week. Since start and until date are within the same week, the interval
       * doesn't matter for the server, it won't create any shifts outside this week
       *
       * TODO: move this logic to server once prefab is out
       */
      { value: this.RRULE_INTERVAL_THIS_WEEK, label: 'This week' },
      { value: 1, label: 'Every week' },
      { value: 2, label: 'Every 2 weeks' },
      { value: 3, label: 'Every 3 weeks' },
      { value: 4, label: 'Every 4 weeks' },
      { value: 5, label: 'Every 5 weeks' },
      { value: 6, label: 'Every 6 weeks' },
      { value: 7, label: 'Every 7 weeks' },
      { value: 8, label: 'Every 8 weeks' },
    ];

    if (!this.Authentication.isPrefab) {
      // remove 'This week' for non-prefab
      this.intervalModes.splice(1, 1);
    }
  }

  $onInit() {
    if (!this.shift.rrule) {
      // Create a default rrule so that when you choose to repeat weekly, the current day is already selected
      this.shift.rrule = {
        interval: 0,
        freq: '',
        byday: '',
      };

      if (this.shift.dtstart) {
        const selectedDay = this.ShiftUtils.weekdays[this.shift.dtstart.getDay()];
        this.shift.rrule.byday = selectedDay;
      }
    }
  }

  $onChanges({ dtstart, dtend }) {
    if (dtstart) {
      if (!dtstart.isFirstChange()) {
        // TODO: probably this condition can be removed
        this._updateRruleByDay(dtstart.currentValue);
      }

      this._refreshRepeatDatepickerOptions();
    }

    if (dtend) {
      this._refreshRepeatDatepickerOptions();
    }
  }

  changeRepeatInterval(value) {
    this.shift.rrule.interval = value;

    if (this.form) {
      this.form.$setDirty();
    }

    if (value === 0) {
      this.shift.rrule.untilDate = undefined;
      this.form.$setValidity('OneDayIsRequired', true);
    }
    if (value && !this.shift.rrule.byday) {
      this.form.$setValidity('OneDayIsRequired', false);
    }
  }

  getIntervalLabel() {
    const mode = this.intervalModes.find((m) => m.value === this.shift.rrule.interval);
    return (mode && mode.label) || 'Never';
  }

  repeatOneYear() {
    this.openedRepeatUntil = false;
    const startDate = new Date(this.shift.rrule.fromDate || this.shift.dtstart);
    this.shift.rrule.untilDate = this._getMaxDate(startDate);
    this.shift.rrule.untilChanged = true;

    if (this.form) {
      this.form.$setDirty();
    }
  }

  _refreshRepeatDatepickerOptions() {
    const opts = this.repeatDatepickerOptions;

    if (this.shift.rrule && 'id' in this.shift.rrule) {
      opts.from.minDate = null;
      opts.from.initDate = new Date(this.shift.rrule.fromDate || this.shift.dtstart);
      opts.until.minDate = null;
      opts.until.initDate = new Date(this.shift.rrule.untilDate || this.shift.dtend);
      opts.until.maxDate = this._getMaxDate(this.shift.dtstart);
    } else {
      opts.from.minDate = new Date(this.shift.dtstart);
      opts.from.initDate = new Date(this.shift.dtstart);
      opts.until.minDate = new Date(this.shift.dtend);
      opts.until.initDate = new Date(this.shift.dtend);
      opts.until.maxDate = this._getMaxDate(this.shift.rrule?.fromDate || this.shift.dtstart);
    }
  }

  _updateRruleByDay(value) {
    const selectedDays = this.shift.rrule.byday ? this.shift.rrule.byday.split(',') : [];

    if (selectedDays.length <= 1 && !this.shift.rrule.id) {
      this.shift.rrule.byday = this.ShiftUtils.weekdays[value.getDay()];
    }

    if (
      this.shift.rrule?.untilDate &&
      value > this.shift.rrule.untilDate &&
      this.shift.rrule.interval === 1
    ) {
      this.shift.rrule.untilDate = undefined;
    }
  }

  _getMaxDate(fromDate = new Date()) {
    return this.Utils.addDays(this.Utils.addYears(fromDate, MAX_RECURRENCE_YEARS), -1);
  }
}

export default {
  controller: RecurrenceOptionsController,
  controllerAs: 'ctrl',
  require: {
    form: '?^form',
  },
  bindings: {
    shift: '<',
    dtstart: '<',
    dtend: '<',
    tooltip: '<',
  },
  templateUrl: recurrenceOptionsComponentUrl,
};
